export const BASE_URL = "/registration";

export const POD_URL = "pod";
export const CALENDAR_URL = "calendar";
export const PRODUCT_SELECTION_URL = "product-selection";
export const CONTACT_DETAILS_URL = "contact-details";
export const ORDER_CONFIRMATION_URL = "order-confirmation";
export const ORDER_URL = "order";
